import { render, staticRenderFns } from "./message-item.vue?vue&type=template&id=197eb2ac&scoped=true"
import script from "./message-item.vue?vue&type=script&lang=js"
export * from "./message-item.vue?vue&type=script&lang=js"
import style0 from "./message-item.vue?vue&type=style&index=0&id=197eb2ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197eb2ac",
  null
  
)

export default component.exports